import { Theme } from '@eversports/react-components/design-tokens/theme'

import Flex from '@eversports/react-components/primitives/Flex'
import MonetaryValue from '@eversports/react-components/primitives/MonetaryValue'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { Localized } from '../../../localization/react'
import { PriceTableItemMembership } from '../../../typings/PriceTable'
import MembershipPromotionInfo from '../../Product/MembershipPromotionInfo'

const useStyles = makeStyles((theme: Theme) => ({
  item: {
    maxWidth: 'fit-content',
    wordBreak: 'break-word',
  },
  priceContainer: {
    minWidth: 'fit-content',
  },
  strikethrough: {
    color: theme.palette.text.disabled,
    textDecoration: 'line-through',
  },
  hideOnMobile: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}))

interface Props {
  membership: PriceTableItemMembership
}

const FullPriceMembershipSummaryItem: React.FC<React.PropsWithChildren<Props>> = ({ membership }) => {
  const classes = useStyles()

  return (
    <Flex flexDirection="column" verticalSpacing="default">
      <Flex justifyContent="space-between" alignItems="baseline" horizontalSpacing="dense">
        <Flex className={classes.item}>
          <Text marginRight="dense">
            {membership.amount > 1 && `${membership.amount}x `}
            {membership.name}
          </Text>
        </Flex>
        <Flex flexDirection="column" alignItems="center" className={classes.priceContainer}>
          {membership.promotion && (
            <Text className={classes.strikethrough}>
              <MonetaryValue
                value={membership.recurringPrice.value}
                currencyCode={membership.recurringPrice.currency}
              />
            </Text>
          )}
          <Text fontWeight="bold">
            <MonetaryValue
              value={membership.promotion?.price.value || membership.recurringPrice.value}
              currencyCode={membership.promotion?.price.currency || membership.recurringPrice.currency}
            />
          </Text>
          {membership.paymentInterval && (
            <Text size="x-small">
              <Localized
                id="membership-interval"
                params={{
                  interval: (
                    <Localized
                      id="interval"
                      params={{
                        intervalValue: membership.paymentInterval.value,
                        intervalType: membership.paymentInterval.type as any,
                      }}
                    />
                  ),
                }}
              />
            </Text>
          )}
        </Flex>
      </Flex>
      {membership.promotion && membership.paymentInterval && (
        <Flex className={classes.hideOnMobile}>
          <MembershipPromotionInfo
            promotion={membership.promotion}
            recurringPrice={membership.recurringPrice}
            paymentInterval={membership.paymentInterval}
          />
        </Flex>
      )}
    </Flex>
  )
}

export default FullPriceMembershipSummaryItem
